import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'

const renderIcon = (color: string) => (
    <path
        d='M15.5833 11.9168L19.25 8.25016M19.25 8.25016L15.5833 4.5835M19.25 8.25016H7.33333C4.80203 8.25016 2.75 10.3022 2.75 12.8335C2.75 15.3648 4.80203 17.4168 7.33333 17.4168H11.9167'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
    />
)

export const ArrowTurnBack: React.FC<IconProps> = ({ color, size }) => (
    <IconWrapper viewBox={'0 0 22 22'} {...{ size, color }} renderIcon={renderIcon} />
)
